export default "__VITE_ASSET__PIyEd787__"